import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { KBD } from "../utils/Keybindings";
import { kbdEvent } from "../utils/Utils";
import Cookies from 'js-cookie';



export default function GroupPicker({ children, onSelect, active = false, offset = [0, 0], showDelete = false, onDelete = () => { } }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    const [pos, setPos] = useState({ top: 0, left: 0 });

    function NumberGrid({ pos, onSelect, onMouseEnter, onMouseLeave }) {
        const chars = [
            "A", "B", "C", "D", "E", "F", "G", "H", "I",
            "J", "K", "L", "M", "N", "O", "P", "Q", "R",
            "S", "T", "U", "V", "W", "X", "Y", "Z", ""
        ];


        if (!active) {
            return;
        }

        return (
            <div
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                style={{
                    position: "absolute",
                    top: pos.top + offset[0],
                    left: pos.left + offset[1],
                    background: "var(--text-black)",
                    padding: 8,
                    border: "1px solid var(--border-secondary)",
                    padding: 1,
                    boxShadow: "0 0px 12px rgba(0,0,0,0.7)",
                    zIndex: 999999,


                }}
            >
                <div style={{ gap: 1, display: "grid", gridTemplateColumns: "repeat(4, 20px)" }}>
                    {chars.map((n) => (
                        <div
                            role="button"
                            tabIndex={0}
                            style={n === 0 ? { gridColumn: "1 / -1" } : undefined}
                            className="ui-grp-picker-btn"
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    hide();
                                    onSelect(n);
                                }
                            }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                hide();
                                onSelect(n);
                            }}
                        >
                            {n}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    const show = () => {
        if (!ref.current) return;

        const r = ref.current.getBoundingClientRect();

        const pickerHeight = 140;
        const spaceBelow = window.innerHeight - r.bottom;

        let top;

        if (spaceBelow < pickerHeight) {
            top = r.top + window.scrollY - pickerHeight;
        } else {
            top = r.bottom + window.scrollY;
        }

        setPos({
            top,
            left: r.left + window.scrollX,
        });

        setVisible(true);
    };

    const hide = () => setVisible(false);

    return (
        <>
            <div
                ref={ref}
                onMouseEnter={show}
                onMouseLeave={hide}
                style={{ display: "inline-block" }}
            >
                {children}
            </div>

            {visible &&
                createPortal(
                    <>
                        <NumberGrid
                            pos={pos}
                            onSelect={(n) => onSelect?.(n)}
                            onMouseEnter={() => setVisible(true)}
                            onMouseLeave={hide}
                        />
                    </>,
                    document.body
                )}
        </>
    );
}